// Components
import { Button, Section } from '@tracklib/kit'

// Hooks
import { useIsAuthenticated } from 'modules/auth/hooks'

// Types
import type { ButtonBlock as ButtonBlockType } from 'types'

import styles from './buttonblock.css'

type ButtonBlockProps = {
  value: ButtonBlockType
}

const ButtonBlock = ({ value: { text, url, show_for } }: ButtonBlockProps): JSX.Element | null => {
  const isAuth = useIsAuthenticated()
  const isExternalButton = url.startsWith('http') || url.startsWith('www')
  if ((show_for === 'logged_in' && !isAuth) || (show_for === 'logged_out' && isAuth)) {
    return null
  }
  return (
    <Section size="small" contentClassName={styles.center}>
      {isExternalButton ? (
        <Button href={url} size="large" target="_blank">
          {text}
        </Button>
      ) : (
        <Button to={url} size="large">
          {text}
        </Button>
      )}
    </Section>
  )
}

export default ButtonBlock
